// setTimeout(() => {
//   const shadowRoot = document.querySelector("#app-embed").shadowRoot;
//   if (shadowRoot) {
//     const style = document.createElement("style");
//     style.textContent = `
//       #form-container-ref section > section{
//         max-width: 60rem;
//         transition: all 0.3s ease;
//       }
//     `;
//     shadowRoot.appendChild(style);
//   }
// }, 1200);



$(document).ready(function () {

  if($("body").hasClass("template--page") && $(".shopify-block").hasClass("shopify-app-block") ){
    const observer = new MutationObserver(() => {
      const formEmbed = document.querySelector("#app-embed");
      if (formEmbed && formEmbed.shadowRoot) {
        const style = document.createElement("style");
        style.textContent = `
          h2._textHeading_2aowh_35 {
          color: rgba(var(--color-heading-foreground), 1) !important;
        }
        ._formDisclaimer_cit2d_38 p {
          font-size: 1.2rem;
          line-height: normal;
        }
        #form-container-ref section > section{
          max-width: 72.6rem;
          transition: all 0.3s ease;
        }
        #form-container-ref section > section > div {
          padding-right: 0 !important;
        }
        button._formSubmitButton_cit2d_96 {
          margin-top: 20px !important;
          text-decoration: none !important;
          position: relative !important;
          overflow: hidden !important;
          z-index: 1 !important;
          border: 1px solid transparent !important;
          transition: all .3s ease !important;
        }
        ._textBody_2aowh_10, span._textBody_2aowh_10, p._textBody_2aowh_10{
          padding-top: 10px;
        }
        #form-container-ref section > section form > button:before {
          content: "";
          position: absolute;
          bottom: 0;
          left: 50%;
          width: 100%;
          height: 100%;
          background: var(--button-text-color);
          border-radius: 50%;
          transform: translate(-50%, 50%) scale(0);
          transition: all .5s ease;
          z-index: -1;
        }
        #form-container-ref section > section form > button:hover {
          background: transparent;
          color: var(--button-background-color);
          border-color: var(--button-background-color) !important;
        }
        #form-container-ref section > section form > button:hover:before {
          width: 130%;
          height: 300%;
          transform: translate(-50%, 40%) scale(1);
        }
        #form-container-ref section > section form input, #form-container-ref section > section form div > button, #form-container-ref section > section form textarea{
          background: transparent;
          color: rgb(var(--color-foreground));
          border-radius: 0;
          font-size: 1.6rem !important;
        }
        #form-container-ref section > section form input + label, #form-container-ref section > section form textarea + label{
          font-size: 1.6rem !important;
        }
        
        `;
        formEmbed.shadowRoot.appendChild(style);
        
        observer.disconnect(); // stop observing once applied
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
});
